import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class ReplaceModal extends Component {
  constructor(props) {
    super(props);
    this.handleContinueClick = this.handleContinueClick.bind(this);
    this.handleStayClick = this.handleStayClick.bind(this);
  }

  handleContinueClick() {
    const {unregisteredSubstitute} = this.props;

    this.props.restorePartsFormValues();
    this.props.getPartMasterInfo(unregisteredSubstitute);
    this.props.getPartRejectionInfo(unregisteredSubstitute);
    this.props.getPartPriceFactors(unregisteredSubstitute);
    this.props.getPartSubstitutes(unregisteredSubstitute);
    this.props.getPartSpecialSubstitutes(unregisteredSubstitute);
    this.props.getPartEquivalences(unregisteredSubstitute);
    this.props.getPartCarCompatibility(unregisteredSubstitute);
  }

  handleStayClick() {
    this.props.changeUnregisteredSubstitute('');
  }

  render() {
    const {trigger, unregisteredSubstitute} = this.props;

    return (
      <Modal
        open={!!unregisteredSubstitute}
        trigger={trigger}
        className='parts-master'
      >
        <Modal.Content>
          ¡El repuesto seleccionado posee un sustituto <strong>{unregisteredSubstitute}</strong>!
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={this.handleStayClick}>Trabajar con el repuesto actual</Button>
          <Button primary onClick={this.handleContinueClick}>Trabajar con el Sustituto</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'unregisteredSubstitute': state.partsMaster.unregisteredSubstitute,
  };
};

const {
  changePartsFormValue,
  getPartMasterInfo,
  getPartPriceFactors,
  getPartSubstitutes,
  getPartSpecialSubstitutes,
  getPartEquivalences,
  getPartCarCompatibility,
  restorePartsFormValues,
  changeUnregisteredSubstitute,
  getPartRejectionInfo,
} = Actions;

export default connect(mapStateToProps, {
  changePartsFormValue,
  getPartMasterInfo,
  getPartPriceFactors,
  getPartSubstitutes,
  getPartSpecialSubstitutes,
  getPartEquivalences,
  getPartCarCompatibility,
  restorePartsFormValues,
  changeUnregisteredSubstitute,
  getPartRejectionInfo,
})(ReplaceModal);
